import React, { useEffect, useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ProductsLineUp from './ProductsLineUp';
import luxeList from '../../constants/luxeScreenType';
import luxeScreen from '../../constants/luxeScreenType';
import { getPriceRevealSaleDuration } from '../../../components/common/PriceRevealPLPBanner/priceRevealUtil';
import { DURING_SALE } from '../../constants/product.constants';
import properties from '../../../modules/ajio-util/properties';
import { gtmListingProductImpressions, getStoreName } from '../../../modules/ga/GTMdatalayer';
import { handleProductImpressionsForDynamicWidget, handleWindowUnloadForDynamicWidgetProductImpressions } from '../../../fleek/utils/feedGaUtils';
import { readCookie } from '../../../components/common/Cookie';
import { getDiscountValue } from '../../../utils/price';
import { getGiftWithProductEnable } from '../../selectors/featureFlagsSelector';

const imageBaseUrl = properties.getProperty('imageBaseUrl');
const dynamicWidgetProductImpressionsIdMsite = 'dynamicWidgetProductImpressionsIdMsite';
const dynamicWidgetProductImpressionsDataMsite = 'dynamicWidgetProductImpressionsDataMsite';

interface ProductWidgetTypes {
  products: any;
  luxe: boolean;
  isBottomSpace: boolean;
  eventPush: any;
  heading: string | undefined;
  priceRevealMetaInfoProductWidget: any;
  flags: any;
  deviceType: any;
  bannerType: string;
  ctaSettings: any;
  viewShowMoreProducts: any;
  dynamicProductWidgetRedirection: any;
  rowNumber: Number;
  banners: any;
  enableGiftWithProduct: Boolean;
  isFromAjiogramLandingPage: boolean;
  isSearchPage?: boolean;
}

const ProductWidget = ({
  products,
  luxe,
  heading,
  isBottomSpace,
  eventPush,
  priceRevealMetaInfoProductWidget,
  flags,
  deviceType,
  bannerType,
  ctaSettings,
  viewShowMoreProducts,
  dynamicProductWidgetRedirection,
  rowNumber,
  banners,
  enableGiftWithProduct,
  isFromAjiogramLandingPage = false,
  isFromPDP = false,
  isSearchPage = false,
  isJioAdsWidget = false,
  feedLogic ='',
  parentProductObj ={},
  position,
  isPriceReveal = false
}: ProductWidgetTypes): JSX.Element => {
  const {
    landingList: { widgetList = '' }
  } = luxeList;
  let { landing: { screenType = '', screenName = '' } = {} } = luxeScreen;

  const saleDuration = getPriceRevealSaleDuration(
    flags,
    deviceType,
    priceRevealMetaInfoProductWidget,
    luxe ? 'luxe' : 'ajio'
  );

  const [hasObserverCall, setObserverCallFlag] = useState(false);
  const productListObserverReference = useRef(null);

  useEffect(() => {
    const handleUnloadEvent = () => {
      handleWindowUnloadForDynamicWidgetProductImpressions(
        dynamicWidgetProductImpressionsDataMsite,
        !!luxe
      );
    };
    window.addEventListener('beforeunload', handleUnloadEvent);
    // Clean up the event when the component unmounts
    return () => {
      window.removeEventListener('beforeunload', handleUnloadEvent);
    };
  }, []);

  useEffect(() => {
    if (!luxe) eventPush({ eventName: `${screenName} ${heading}`, widget_name: 'Product Widget' });
  }, []);

  const productImpressionsEventPush = (product = {}) => {
    if(!isJioAdsWidget){
    const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET' || false;
    const storeType = getStoreName();
    let impressions = product.map((data, index) => {
      const {
        name: description,
        brand,
        code = '',
        price: { value: priceValue = '' } = {},
        fnlColorVariantData: {
          colorGroup: productColor = '',
          exclusiveTill: isExclusive = '',
          productTag = ''
        } = {},
        brickCategory: productCategory = '',
        brickName,
        discount = '',
        segmentId = '',
        experimentId = '',
        offerPrice: { giftAvailable = false } = {},
        catalogName = ''
      } = data;
      const productId = code && code.length > 9 ? code.substring(0, 9) : code;
      const tag = isExclusive ? 'Exclusive' : productTag;
      let listValue = `${screenName} - ${heading}`;
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      if (isDynamicProductWidget) {
        listValue =
          banners.widgetLevel.toLowerCase() === 'user'
            ? `user_level_${banners?.feedLogic}_${heading}_${rowNumber}`
            : `dynamic_${banners?.feedLogic}_${heading}_${rowNumber}`;
      }

      let impressionData = {
        name: description,
        id: productId,
        price: priceValue,
        brand,
        category: productCategory,
        list: listValue,
        position: index,
        dimension6: description,
        dimension7: productId, // pass value for product_id
        dimension8: brand, // pass value for product_brand
        dimension9: priceValue, // pass value for product_price
        dimension10: productColor, // pass value for product_color
        dimension11: productCategory, // pass value for product_category
        dimension12: brickName, // pass value for product_brick
        dimension13: tag, // pass value for product_tag
        dimension14: '', // pass value for product_size
        dimension15: discount, // pass value for product_trade_discount
        dimension16: storeType, // pass value for Store_type,
        dimension23: storeType,
        dimension60: dimension60Data,
        dimension170: getDiscountValue(discount),
        catalogName: catalogName ?? "",
      };
      if (enableGiftWithProduct && giftAvailable) {
        impressionData.dimension166 = `GetFreebies`;
      }
      return impressionData;
    });
    if (isDynamicProductWidget) {
      impressions.forEach(imprsn => {
        handleProductImpressionsForDynamicWidget(
          dynamicWidgetProductImpressionsDataMsite,
          dynamicWidgetProductImpressionsIdMsite,
          imprsn,
          storeType,
          isSearchPage ? 'search screen' : '',
          isSearchPage ? 'search screen' : screenType,
          '',
          !!luxe
        );
      });
    } else {
      gtmListingProductImpressions({
        impressions,
        list: 'landing screen',
        store_type: storeType,
        page_name: '',
        page_type: screenType,
        contains_luxe: !!luxe
      },'','','','','','','','ProductWidget','Horizontal','');
    }
    }
  };

  const observerCallback = useCallback(() => {
    if (products && products.length) productImpressionsEventPush(products.slice(0, 2));
  }, [products]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasObserverCall) {
          setObserverCallFlag(true);
          observerCallback();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (productListObserverReference.current) {
      observer.observe(productListObserverReference.current);
    }
    return () => {
      if (productListObserverReference.current) {
        observer.unobserve(productListObserverReference.current);
      }
    };
  }, [productListObserverReference, observerCallback, hasObserverCall]);

  return (
    <div style={{ paddingBottom: isJioAdsWidget ? '0px' : '32px', paddingTop: isJioAdsWidget ? '0px': '24px' }} ref={productListObserverReference}>
      <ProductsLineUp
        products={products}
        luxe={luxe}
        titleGutter="sm"
        containerClass={isBottomSpace ? 'margin-bottom' : ''}
        eventPush={eventPush}
        eventPushObj={{ event_label: `${screenName}- ${heading}` }}
        productWidgetCard
        pageType={screenName}
        pageList={widgetList}
        isPriceReveal={isPriceReveal}
        isPriceRevealDuringSale={saleDuration === DURING_SALE}
        bannerType={bannerType}
        ctaSettings={ctaSettings}
        viewShowMoreProducts={viewShowMoreProducts}
        dynamicProductWidgetRedirection={dynamicProductWidgetRedirection}
        heading={heading}
        banners={banners}
        rowNumber={rowNumber}
        widgetTitle={`${bannerType}-${heading}`}
        isFromAjiogramLandingPage={isFromAjiogramLandingPage}
        isFromPDP={isFromPDP}
        isSearchPage={isSearchPage}
        isJioAdsWidget = {isJioAdsWidget}
        feedLogic={feedLogic}
        parentProductObj = {parentProductObj}
        position={position}
        priceRevealMetaInfo={priceRevealMetaInfoProductWidget}
        {...(isFromPDP ? { itmSource: 'widget', itmSourceDetail: heading || '' } : {})}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    enableGiftWithProduct: getGiftWithProductEnable(state?.flags)
  };
};

export default connect(mapStateToProps, null)(ProductWidget);
 